module.exports = __webpack_public_path__ + "img/gm.5e989444.png";